export default "__VITE_ASSET__BVKoNs1___"